declare namespace $ {

	export class $shm_projects_task_chat extends $shm_projects_goal_chat {
		refresh( next?: number ): number
	}
	
}

//# sourceMappingURL=chat.view.tree.d.ts.map